export enum Currency {
	USD = 'USD',
	BYN = 'BYN',
}
